export default __webpack_public_path__ + "static/media/zigbee.96dfbbfa.svg";